import { registerBlockType } from "@wordpress/blocks";
import config from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";
import MissionaryInfoEditor from "./MissionaryInfoEditor";

registerBlockType(config.name, {
  ...config,
  edit: MissionaryInfoEditor,
  save() {
    return <InnerBlocks.Content />;
  },
});
